<template>
  <div class="my-resources">
    <a-card title="我上传的资源">
      <div class="statistics">
        <a-statistic title="总上传数量" :value="statistic.totalNum" style="margin-right: 50px">
          <template #suffix>个</template>
        </a-statistic>
        <a-statistic title="总上传大小" :value="statistic.totalSize | toFileSize" style="margin-right: 50px">
          <!-- <template #suffix>Mb</template> -->
        </a-statistic>
      </div>
    </a-card>
    <a-table :loading='loading' :pagination="false" :columns="columns" :data-source="objectList">
      
      <template slot="preview" slot-scope="data">
        <img class="preview-img" :src="data.thumbnailUrl"></img>
      </template>

      <template slot="create_time" slot-scope="data">
        <span>{{data | dateFormat}}</span>
      </template>

      <template slot="size" slot-scope="data">
        <span>{{data | toFileSize}}</span>
      </template>

      <template slot="actions" slot-scope="_, records">
        <a-popconfirm
          title="确认删除？"
          ok-text="是"
          cancel-text="否"
          @confirm="handleRemove(records.id)">
          <a-button size="small" type='link'>删除</a-button>
        </a-popconfirm>
        <a-button size="small" type='link' @click="clip(records.url)">复制链接</a-button>
        <a-button size="small" type='link' @click="openImage(records.url)">打开</a-button>
      </template>
    </a-table>
  </div>
</template>

<script>
import { getObjectList, remove, getStatistic } from '@/api/object'
import { message } from 'ant-design-vue'
import { mapState } from 'vuex'
export default {
  created() {
    this.requestData()
  },
  data () {
    return {
      loading: false,
      columns: [
        {
          title: '预览',
          scopedSlots: { customRender: 'preview' }
        },
        {
          title: '原始文件名',
          dataIndex: 'originalName'
        },
        {
          title: '文件类型',
          dataIndex: 'mimetype'
        },
        {
          title: '文件大小',
          dataIndex: 'size',
          scopedSlots: { customRender: 'size' }
        },
        {
          title: '上传时间',
          dataIndex: 'create_time',
          scopedSlots: { customRender: 'create_time' }
        },
        {
          title: '操作',
          scopedSlots: { customRender: 'actions' }
        }
      ],
      objectList: [],
      statistic: {}
    }
  },
  computed: {
    ...mapState('SettingModule', ['copyMode'])
  },
  methods: {
    async requestData () {
      this.loading = true
      try {
        const data = await getObjectList()
        this.objectList = data
        this.statistic = await getStatistic()
      } finally {
        this.loading = false
      }
    },
    async handleRemove(objectId) {
      this.loading = true
      try {
        await remove(objectId)
        message.success('删除成功')
        this.requestData()
      } finally {
        this.loading = false
      }
    },
    clip(text) {
      if (this.copyMode === 'md') {
        text = `![image](${text})`
      }
      const elem = document.createElement('textarea')
      elem.innerText = text
      document.body.appendChild(elem)
      elem.select()
      document.execCommand('copy')
      document.body.removeChild(elem)
      message.success('链接已经复制到剪贴板')
    },
    openImage(url) {
      window.open(url)
    }
  }
}
</script>

<style scoped lang='scss'>
.my-resources {
  background-color: white;
}
.table-header {
  padding: 15px;
  background-color: white;
}
.preview-img {
  border: solid 1px #e3e3e3;
  object-fit: cover;
  height: 50px;
  width: 50px;
}
.statistics {
  display: flex;
}
</style>